export default {
    outside_milk: 'Outside Milk',
    member_producer: 'Member Producer',
    comingled: 'Comingled',
};
